import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import AppButon from '../AppButon/AppButon';
import CheckBox from '../CheckBox/CheckBox';
import OnboardingNew from '../../OnboardingNew';
import Step2 from '../Steps/Step2';
import * as S from './PassportUploadDetails.styles';
import {
  tokenSelector,
  emailSelector,
  userCountrySelector,
  errorSelector,
  userDataSelector,
  UserNumberSelector,
} from '../../../../../store/selectors';
import {
  submitPassportDetails,
  submitDetails,
  setAgentDataNew,
} from '../../../../../store/actions/thunk';
import {CREATE_PASSWORD_PAGE_URL, DOCUMENT_UPLOAD_KYC_URL} from '../../../../../constants';
import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
  getCrid,
} from '../../../../../../../myaccount/src/utils/redirectWithCrId';

const PassportUploadDetails = () => {
  const crId = getCrid();

  if (!crId) {
    redirectToSameWindowWithoutRefresh('/agent/upload-passport-details');
  }

  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector(tokenSelector);
  const email = useSelector(emailSelector);
  const error = useSelector(errorSelector);
  const userNumber = useSelector(UserNumberSelector);
  const userCountry = useSelector(userCountrySelector);
  const userBusinessInfo = useSelector(userDataSelector);
  const [disableSubmitButton, setDisableButton] = useState(true);
  const [approve, setApprove] = useState(false);
  const [disableInput, setDisableInput] = useState(false);

  const [passportDetails, setPassportDetails] = useState({
    passport_doc: '',
    surname: '',
    givenName: '',
    passportNumber: '',
    fullName: '',
    nationality: '',
    mobile: '',
    title: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [passportSubmitSuccess, setPassportSubmitSuccess] = useState(false);
  const [passportLoader, setPassportLoader] = useState(false);
  const [showAcklSection, setShowAcklSection] = useState({
    flag: false,
    message: '',
  });
  const [mismatchAcklFlag, setMismatchAcklFlag] = useState(false);

  useEffect(() => {
    const passportDetailsObj = {...passportDetails};
    if (!passportDetailsObj.mobile) {
      passportDetailsObj.mobile = userNumber.mobile;
      setPassportDetails({...passportDetailsObj});
    }
  }, [userNumber]);

  useEffect(() => {
    const onPageLoad = () => {
      logPageLoadEvents('onboarding:personaldetails|mypartner', {
        eVar15: 'onboarding:personaldetails|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/upload-passport-details/',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      });
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  useEffect(() => {
    let flag = false;
    for (const key in passportDetails) {
      if (key.toLowerCase() !== 'surname' && passportDetails[key] === '') {
        flag = true;
      }
      if (key.toLowerCase() === 'mobile' && passportDetails[key]?.length !== 9) {
        flag = true;
      }
    }
    if (flag === true) {
      setDisableButton(true);
    } else setDisableButton(false);
  }, [passportDetails]);

  const handleSteps = () => {
    //myPartner_onboarding_continue
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:personaldetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_continue',
    });

    setPassportLoader(true);
    const dataToSubmit = {
      token: token,
      email: email,
      mobile: passportDetails?.mobile,
      agency_name: userBusinessInfo?.agencyName,
      address: userBusinessInfo?.address,
      full_name: passportDetails?.fullName,
      title: passportDetails?.title === 'Mr.' ? 1 : passportDetails?.title === 'Mrs.' ? 2 : 3,
    };
    let fd = new FormData();
    for (var key in dataToSubmit) {
      fd.append(key, dataToSubmit[key]);
    }
    dispatch(submitDetails(fd, dataToSubmit, submitBusinessDetailsSuccess, errorCallback));
  };

  const approveHandler = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:personaldetails|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/upload-license',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_uploadApprove',
    });
    const data = {
      passport_doc: passportDetails?.passport_doc,
      legal_owner_name: passportDetails?.fullName,
      nationality: passportDetails?.nationality,
      passport_number: passportDetails?.passportNumber,
      mobile: passportDetails?.mobile,
      ed_license_number: userBusinessInfo?.ed_license_number,
      title: passportDetails?.title === 'Mr.' ? 1 : passportDetails?.title === 'Mrs.' ? 2 : 3,
    };
    setIsLoading(true);
    setDisableInput(true);
    dispatch(
      submitPassportDetails(
        {...data},
        token,
        handlePassportSubmiDetailsSuccess,
        handlePassportSubmiDetailsError,
      ),
    );
  };

  const handlePassportSubmiDetailsSuccess = response => {
    setIsLoading(false);
    if (response?.show_ack_section) {
      const obj = {
        message: response?.message,
        flag: true,
      };
      setShowAcklSection({...obj});
    }
    if (response?.manual_qc) {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:personaldetails|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/upload-license',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_continue',
      });
    }
    setPassportSubmitSuccess(true);
  };

  const handlePassportSubmiDetailsError = () => {
    setIsLoading(false);
    setApprove(false);
    setDisableInput(false);
  };

  const successCallback = response => {
    //TO BE FIXED LATER
    if (response?.screen === 'kyc_doc') {
      history.push(`${DOCUMENT_UPLOAD_KYC_URL}?crId=${getCrid()}`);
    } else {
      history.push(`${CREATE_PASSWORD_PAGE_URL}?crId=${getCrid()}`);
    }
  };

  const errorCallback = err => {
    setPassportLoader(false);
  };

  const submitBusinessDetailsSuccess = () => {
    setPassportLoader(false);
    dispatch(setAgentDataNew(token, successCallback, errorCallback));
  };

  const onNameAcklClick = () => {
    setMismatchAcklFlag(mismatchAcklFlag => !mismatchAcklFlag);
  };

  return (
    <OnboardingNew step={2}>
      <S.Container>
        <S.Content>
          <Step2
            setPassportDetails={setPassportDetails}
            approveHandler={approveHandler}
            passportDetails={passportDetails}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            disableSubmitButton={disableSubmitButton}
            approve={approve}
            setApprove={setApprove}
            disableInput={disableInput}
            setDisabledInput={setDisableInput}
          />
        </S.Content>
      </S.Container>
      {error?.msg && <S.ErrorMsg>{error.msg}</S.ErrorMsg>}
      <S.ContentFooter>
        {showAcklSection?.flag && (
          <CheckBox onChange={onNameAcklClick} id={'ackl_section'}>
            <p>{showAcklSection?.message}</p>
          </CheckBox>
        )}
        <AppButon
          buttonText={'Save & Continue'}
          isDisabled={!passportSubmitSuccess || (showAcklSection?.flag ? !mismatchAcklFlag : false)}
          onPress={handleSteps}
          isError={false}
          classes={''}
          butonWidth="40px"
          isLoading={passportLoader}
        />
        <p className="textCenter greyText font12 appendTop5">
          By proceeding, you agree to MakeMyTrip's T&Cs and Privacy Policy
        </p>
      </S.ContentFooter>
    </OnboardingNew>
  );
};

export default PassportUploadDetails;
